import React from 'react'
import { Box, Grid, Card, Text, Flex, ActionIcon, ThemeIcon, Divider } from '@mantine/core'
import { 
  IconTruck,
  IconSearch,
  IconBox,
  IconClockHour4,
  IconCheck,
  IconCashBanknote,
  IconInfoCircle,
  IconNotes,
  IconChecklist,
  IconCircleX,
  IconCreditCardRefund,
  IconClockHour10
} from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'

const DashboardDivisionCount = ({ statistic }) => {
  const navigate = useNavigate()

  const sortStatuses = (statusId) => {
    const dataStatus = statistic.statuses
    return dataStatus.find((val) => val.id === statusId)
  }

  const dataTopDivision = [
    {
      title: `Warehouse Tracking (${statistic.warehouseTracking || 0})`,
      route: '/order/division/purchase',
      division: [
        {
          ...sortStatuses(81),
          name: 'goods paid to supplier',
          icon: IconTruck
        },
        {
          ...sortStatuses(46),
          icon: IconSearch
        },
        {
          ...sortStatuses(47),
          icon: IconBox
        },
      ]
    },
    {
      title: `Purchase & Warehouse Division (${statistic.purchase + statistic.warehouse })`,
      route: '/order/division/purchase',
      division: [
        {
          ...sortStatuses(10),
          icon: IconClockHour4
        },
        {
          ...sortStatuses(81),
          icon: IconTruck
        },
        {
          ...sortStatuses(46),
          icon: IconSearch
        },
      ]
    },
    {
      title: `Logistic Division (${statistic.logistic || 0})`,
      route: '/order/division/logistic',
      division: [
        {
          ...sortStatuses(47),
          icon: IconBox
        },
        {
          ...sortStatuses(11),
          icon: IconTruck
        },
        {
          ...sortStatuses(12),
          icon: IconTruck
        },
      ]
    },
    {
      title: `Aftersales Division (${statistic.afterSales || 0})`,
      route: '/order/division/aftersales',
      division: [
        {
          ...sortStatuses(79),
          icon: IconCheck
        },
        {
          ...sortStatuses(80),
          icon: IconCashBanknote
        },
        {
          ...sortStatuses(40),
          icon: IconCheck
        },
      ]
    }
  ]

  const dataBottomDivision = [
    {
      title: `Sales Division (${statistic.salesDivision || 0})`,
      route: '/order/division/sales',
      division: [
        {
          ...sortStatuses(44),
          icon: IconNotes
        },
        {
          ...sortStatuses(78),
          icon: IconChecklist
        },
        {
          ...sortStatuses(37),
          icon: IconClockHour10
        },
        {
          ...sortStatuses(55),
          icon: IconCheck
        },
      ]
    },
    {
      title: `Sourcing Request (${statistic.sourcingRequest || 0})`,
      route: '/request/sourcing-request',
      division: [
        {
          ...sortStatuses(82),
          icon: IconClockHour4
        },
        {
          ...sortStatuses(83),
          icon: IconClockHour4
        },
        {
          ...sortStatuses(84),
          icon: IconCheck
        },
        {
          ...sortStatuses(85),
          icon: IconCircleX
        },
      ]
    },
    {
      title: `Product Quote (${statistic.productQuote || 0})`,
      route: '/request/sourcing-quote',
      division: [
        {
          ...sortStatuses(61),
          icon: IconNotes
        },
        {
          ...sortStatuses(62),
          icon: IconChecklist
        },
        {
          ...sortStatuses(60),
          icon: IconCheck
        },
        {
          ...sortStatuses(63),
          icon: IconCircleX
        },
      ]
    },
    {
      title: `Non Active Order (${statistic.nonActive || 0})`,
      route: '/order/division/sales',
      division: [
        {
          ...sortStatuses(68),
          icon: IconClockHour4
        },
        {
          ...sortStatuses(9),
          icon: IconClockHour4
        },
        {
          ...sortStatuses(39),
          icon: IconCircleX
        },
        {
          ...sortStatuses(45),
          icon: IconCircleX
        },
        {
          ...sortStatuses(13),
          icon: IconCreditCardRefund
        },
      ]
    },
  ]

  const mappingDivision = (data, position) => {
    const remapDivision = data.map((val, index) => {

      const mappingDivision = (division) => {
        const remapDivision = division.map((val, index) => {
          return (
            <Box key={index}>
              <Flex justify='space-between' align='center'>
                <Flex gap={6} align='center'>
                  <ThemeIcon variant="light" color="red" radius="xl" size='sm'>
                    <val.icon style={{ width: '70%', height: '70%' }} />
                  </ThemeIcon>
                  <Text fz={12} tt='capitalize'>{val.name}</Text>
                </Flex>
                <Text fz={12} fw={500}>{val.count}</Text>
              </Flex>
              <Divider my="xs" />
            </Box>
          )
        })
        return remapDivision
      }

      return (
        <Grid.Col span={{ base: 12, md: 3, lg: 3 }}>
          <Card shadow="sm" padding="md" radius="md" withBorder key={index} mih={position === 'bottom' ? 290 : 'auto'}>
            <Flex justify='space-between' align='center' mb={14}>
              <Text fz={13} fw='bold'>{val.title}</Text>
              <ActionIcon variant="transparent" color='blue' mr={-8} onClick={() => navigate(val.route)}>
                <IconInfoCircle style={{ width: '70%', height: '70%' }} stroke={1.5} />
              </ActionIcon>
            </Flex>
            <Box>
              {mappingDivision(val.division)}
            </Box>
          </Card>
        </Grid.Col>
      )
    })
    return remapDivision
  }

  return (
    <Box>
      <Grid gutter="sm">
        {mappingDivision(dataTopDivision, 'top')}
        {mappingDivision(dataBottomDivision, 'bottom')}
      </Grid>
    </Box>
  )
}

export default DashboardDivisionCount